import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reducePolicyLogContent } from '../../actions/policy/reducePolicyLogContent';

export function* getLogContentSaga(action) {
    try {
        yield put(reduceLoading({ code: 'getLogContent', value: true }));
        const session = yield getSessionSaga();
        const response = yield call(fetch, `/api/log/log-content?logName=${action.payload.logName}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });
        const result = yield call([response, 'json']);
        yield put(reduceOperation(result.operation));
        //if (!result.operation.status) {
        //    yield put(reduceLoading({ code: `getLogContent`, value: false }));
        //    return;
        //}
        yield put(reducePolicyLogContent({ code: action.payload.eventCode, value: result }));
        yield put(reduceLoading({ code: 'getLogContent', value: false }));
        return;
    } catch (error) {
        console.log('Error while calling Get API Log Content - ', error);
        yield put(reduceLoading({ code: 'getLogContent', value: false }));
        return;
    }
}
